import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { JWTService } from './jwt.service';

/**
 * Safari won't set cookies in a 3rd party iframe
 * if the user hasn't navigated to that frame's domain before.
 *
 * As a fallback mechanism, let's use a jwt in a http header + local storage
 */
@Injectable()
export class JWTHeaderInterceptor implements HttpInterceptor {
  constructor(private jwtService: JWTService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request and replace the original headers with an Authorization header,
    // but only if the request doesn't already have such a header ( /authenticate handles a different bearer token )
    let additionalHeader = {};
    if (this.jwtService.getJwt() && !request.headers.get('Authorization')) {
      additionalHeader = {
        headers: request.headers.set('Authorization', 'Bearer ' + this.jwtService.getJwt()),
      };
    }
    const clonedRequest = request.clone(additionalHeader);
    return next.handle(clonedRequest);
  }
}
